/**
 * mostly trimmed from old component Details Section
 */
import React, { useContext, useEffect, useState } from 'react';
import { Flex, Text } from '@bb/elements-web';
import { Button } from 'components';
import styled from 'styled-components';
import correctShowingTypeLabel from 'utils/correctShowingTypeLabel';

import { AppointmentController } from 'api';
import errorReporter from '@app/errorReporter';
import { findManyClientsByIds } from 'api/ContactController';
import InviteBuyer, {
  SearchResult,
} from '../../../../components/InviteBuyer/index';
import InfoContainer from '../InfoContainer';
import { APPT_STATUSES_TO_INVITE, COLUMN_MARGIN_TOP } from '../../constants';
import ShowingDetailsContext from '../../ShowingDetailsV2/ShowingDetailsContext';

const TypeBuyerColumn: React.FC = () => {
  const { appointment, listing } = useContext(ShowingDetailsContext);
  const [buyersUpdated, setBuyersUpdated] = useState(false);
  const [savingBuyers, setSavingBuyers] = useState(false);
  const [inviteBuyers, setInviteBuyers] = useState<SearchResult[]>([]);
  const getBuyersLabel = async (buyers?: string[]) => {
    try {
      const buyerContacts = buyers?.length
        ? await findManyClientsByIds(buyers)
        : [];

      setInviteBuyers(
        buyerContacts
          .map(buyer => ({
            label: `${buyer.firstName} ${buyer.lastName}`,
            value: buyer.id!,
          }))
          .sort((buyer1: { label: string }, buyer2: { label: string }) =>
            buyer1.label.localeCompare(buyer2.label),
          ),
      );
    } catch (err) {
      errorReporter.error(`Error loading buyers: ${err}`);
    }
  };

  const updateBuyers = async () => {
    setSavingBuyers(true);
    try {
      await AppointmentController.saveBuyers(
        appointment.id,
        inviteBuyers.map(buyer => buyer.value),
      );
    } catch (err) {
      errorReporter.error(`Error saving buyers: ${err}`);
    }
    setBuyersUpdated(false);
    setSavingBuyers(false);
  };
  useEffect(() => {
    getBuyersLabel(appointment.buyers);
  }, [appointment.buyers]);
  return (
    <StyledFlex wrap="wrap" vertical>
      <InfoContainer
        icon="userHome"
        colorName="grey"
        data-cy="showingDetails-appointment-type"
        iconPaddingTop={2}
      >
        <Text size="large">{correctShowingTypeLabel(appointment.type)}</Text>
      </InfoContainer>
      {APPT_STATUSES_TO_INVITE.includes(appointment.status) && (
        <InfoContainer
          icon="userGroupAddOutlined"
          data-cy="showingDetails-inviteBuyers"
          colorName="grey"
          iconPaddingTop={2}
        >
          <>
            <Text thickness="bold">Invite buyers</Text>
            <Flex wrap="wrap">
              <StyledSearchBar>
                <InviteBuyer
                  agent={appointment.coop}
                  value={inviteBuyers}
                  listing={listing}
                  onValueChange={buyers => {
                    setInviteBuyers(buyers);
                    setBuyersUpdated(true);
                  }}
                />
              </StyledSearchBar>
              <Button
                onClick={updateBuyers}
                loading={savingBuyers}
                disabled={!buyersUpdated}
              >
                Update
              </Button>
            </Flex>
          </>
        </InfoContainer>
      )}
    </StyledFlex>
  );
};

export default TypeBuyerColumn;

const StyledFlex = styled(Flex)`
  margin-top: ${COLUMN_MARGIN_TOP}px;
`;
const StyledSearchBar = styled.div`
  min-width: 20vh;
`;
